import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5b98e66c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b98e66c')) {
      api.createRecord('5b98e66c', component.options)
    } else {
      api.reload('5b98e66c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5b98e66c", function () {
      api.rerender('5b98e66c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/collegeNavSet/index.vue"
export default component.exports